"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var SvgIcon_1 = require("./internal/SvgIcon");

exports.NotificationBellOn = function (props) {
  return react_1.default.createElement(SvgIcon_1.SvgIcon, tslib_1.__assign({}, props), react_1.default.createElement("svg", {
    viewBox: "0 0 16 16"
  }, react_1.default.createElement("path", {
    fillRule: "evenodd",
    d: "M1.05444 7.00001C1.10816 4.53997 2.45689 2.39772 4.44963 1.21826L5.18296 2.4113C3.58994 3.34468 2.50856 5.04549 2.45487 7.00001H1.05444ZM13.7031 12.002L12.0009 9.98536V6.99805C12.0009 6.07748 11.7184 5.25717 11.1533 4.53712C10.5882 3.81706 9.86586 3.34994 8.9863 3.13575L8.99997 2.99903C8.99997 2.72559 8.90427 2.49089 8.71286 2.29493C8.52145 2.09896 8.28448 2.00098 8.00192 2.00098C7.71937 2.00554 7.48239 2.10352 7.29099 2.29493C7.09502 2.48634 6.99704 2.72103 6.99704 2.99903L7.03122 3.13575C6.15622 3.34994 5.43161 3.81706 4.85739 4.53712C4.28773 5.25717 4.0029 6.07748 4.0029 6.99805V9.98536L2.31442 12.002H13.7031ZM6.91501 14.0801C7.21579 14.3718 7.58037 14.5176 8.00876 14.5176C8.4417 14.5176 8.80856 14.3718 9.10935 14.0801C9.41013 13.7884 9.57419 13.4284 9.60153 13H6.41599C6.44789 13.4284 6.61423 13.7884 6.91501 14.0801ZM13.5451 7.00001H14.9455C14.8918 4.54116 13.5444 2.39979 11.5532 1.21997L10.8204 2.41328C12.4115 3.34708 13.4914 5.04687 13.5451 7.00001Z",
    clipRule: "evenodd"
  })));
};